import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	isNotANumber: {
		id: 'servicedesk-customer-service-custom-details.common.field.number-field.is-not-a-number',
		defaultMessage: 'Enter a number that doesn’t contain spaces, letters or special characters.',
		description: 'Validation error message in red text shown when entry is not a number.',
	},
});
